import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard to prevent unauthenticated users from accessing protected routes
 */
export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.isAuthenticated$.pipe(
        take(1),
        map(isAuthenticated => {
            if (isAuthenticated) {
                return true;
            }

            // Redirect to login if not authenticated
            router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        })
    );
};

/**
 * Guard to prevent authenticated users from accessing auth routes (login, register)
 */
export const guestGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);

    return authService.isAuthenticated$.pipe(
        take(1),
        map(isAuthenticated => {
            if (!isAuthenticated) {
                return true;
            }

            // Redirect to dashboard if already authenticated
            router.navigate(['/app/dashboard']);
            return false;
        })
    );
};
